import { MoveableOverlay } from "./MoveableOverlay";
import _ from 'lodash'

export class MoveableOverlayAnimation extends MoveableOverlay {

	type: string = "animation";

	file: any;

	constructor(variationId: string, twinnedId: string) {
		super(variationId, twinnedId);

		this.file = null;

		/* 		this.moveableObject = {
					draggable: true,
					throttleDrag: 0,
					resizable: false,
					throttleResize: 1,
					keepRatio: true,
					scalable: true,
					throttleScale: 1,
					rotatable: true,
					throttleRotate: 0,
					pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
					origin: false,
					snappable: true,
					snapVertical: true,
					snapHorizontal: true,
					snapElement: true,
					snapThreshold: 0,
					snapCenter: true,
				};
				this.moveabaleStyle = {
					width: "23%",
					//height: "30%",
					left: "5%",
					top: "5%",
					//right: 0,
					//bottom: 0,
					position: "absolute",
					userSelect: "none"
				}; */
	}

	copyProperties(overlayToCopy: MoveableOverlayAnimation) {
		super.copyProperties(overlayToCopy);
		this.file = _.cloneDeep(overlayToCopy.file);
	}

	copy(): MoveableOverlayAnimation {
		let copy = new MoveableOverlayAnimation(this.variationId, this.twinnedId);

		copy.copyProperties(this);
		return copy;
	}

	static copyFromParsed(parsedObject: any): MoveableOverlayAnimation {
		let copy = new MoveableOverlayAnimation(parsedObject.variationId, parsedObject.twinnedId ? parsedObject.twinnedId : null);

		copy.copyProperties(parsedObject);
		return copy;
	}

	getOverlayXYWH(videoPreviewPixelsWidth, outerVideoResolutionX, videoScale, currentSize) {
		if (this.position === '' || !this.file) {
			return null;
		}

		let width = outerVideoResolutionX;
		let p = width / videoPreviewPixelsWidth;
		let k = p * videoScale;

		let overlayCenterXY = this.getOverlayCenterXY(videoPreviewPixelsWidth, currentSize);
		let tx = overlayCenterXY.x * k;
		let ty = overlayCenterXY.y * k;
		let w = this.offsetDimensions.width * k * this.transforms.scaleX;
		let h = this.offsetDimensions.height * k * this.transforms.scaleX;

		return {
			x: tx,
			y: ty,
			w: w,
			h: h
		};
	}

	getPathAndLastKeyAnimationProp(fileAnimation, pathString) {
		const keys = pathString.split(/\.|\[|\]/);
		const lastIndex =
			keys[keys.length - 1] !== "" ? keys.length - 1 : keys.length - 2;
		const lastKey = keys[lastIndex];

		let path = fileAnimation;
		keys.forEach((key, index) => {
			if (key !== "" && index !== lastIndex) {
				path = path[key];
			}
		});

		return { path: path, key: lastKey };
	}

	getAnimationPropAtPath(fileAnimation, pathString) {
		return this.getPathAndLastKeyAnimationProp(fileAnimation, pathString)
			.path[
			this.getPathAndLastKeyAnimationProp(fileAnimation, pathString).key
		];
	}

	getAnimationLayerColor(fileAnimation, pathString) {
		const colorArrFraction = this.getAnimationPropAtPath(
			fileAnimation,
			pathString
		);
		const [r, g, b] = colorArrFraction.map((item) => Math.round(item * 255));
		return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
	}

	updatePropInAnimationPath(value, overlay, fileAnimation, pathString) {
		const pathAndLastKey = overlay.getPathAndLastKeyAnimationProp(
			fileAnimation,
			pathString
		);
		pathAndLastKey.path[pathAndLastKey.key] = value;
	}

	getAllTextFields() {
		const textsFields = [];
		this.file.layers.forEach(layer => {
			//Пока добавляем только title тексты
			if (layer.text?.isTitle) {
				const layerTextValue = this.getAnimationPropAtPath(
					this.file.json,
					layer.text.path
				);
				textsFields.push({ value: layerTextValue, type: 'title' });
			}
		});
		return textsFields;
	}
}